export default [
  "Arial",
  "Helvetica",
  "Verdana",
  "Trebuchet MS",
  "Geneva",
  "Times New Roman",
  "Times",
  "Georgia",
  "Palatino Linotype",
  "Book Antiqua",
  "Courier New",
  "Courier",
  "Lucida Console",
  "Monaco",
  "Comic Sans MS",
  "Impact",
  "Jokerman",
];
